import contact from '../../store/modules/contact.js';
import {
  mapActions,
  mapGetters
} from 'vuex'


export default {

  components: {
    contact
  },

  props: {},

  computed: {
  },

  data() {
    return {
      DemandeOptions: ["Demande de numérisation","Recherche d'archivage","Autre"],
      Demande: {
        objet: '',
        nom: '',
        prenom: '',
        cp: '',
        ville: '',
        email: '',
        numero: '',
        message: '',
      },
      InfoMail : ''
    };
  },

  watch: {},

  methods: {
    ...mapActions(['getContact']),

    sendmail(){
      this.InfoMail=""
      let newdemande = {}
      newdemande = this.Demande
      this.getContact(newdemande).then(res => {
        this.$refs.ContactForm.reset();
        this.InfoMail = "Mail envoyé"
        console.log("Demande envoyée au service d'assistance")
      }).catch(err => {
        this.InfoMail = "L'envoie du mail a échoué"
        console.log(err)
      }) 
    },
  },

  mounted() {
  },

};